<div class="app-main__inner">

  <!-- ══ SUCCESS BANNER ══════════════════════════════════════════════════════ -->
  <div class="ir-success-card card" *ngIf="successResult">
    <div class="card-body text-center py-5">
      <div class="ir-success-icon mx-auto mb-3"><i class="pe-7s-check"></i></div>
      <h4 class="fw-bold text-success mb-1">Transaction Saved</h4>
      <p class="text-muted mb-4">{{ successResult.message }}</p>
      <div class="d-flex justify-content-center flex-wrap gap-2 mb-4">
        <span class="badge bg-success-subtle text-success-emphasis px-3 py-2" *ngIf="successResult.booksReturned > 0">
          <i class="pe-7s-back me-1"></i>{{ successResult.booksReturned }} Returned
        </span>
        <span class="badge bg-primary-subtle text-primary-emphasis px-3 py-2" *ngIf="successResult.booksIssued > 0">
          <i class="pe-7s-bookmarks me-1"></i>{{ successResult.booksIssued }} Issued
        </span>
        <span class="badge bg-secondary-subtle text-secondary-emphasis px-3 py-2">
          Holding {{ successResult.totalBooksNow }} / {{ successResult.maxBooksAllowed }}
        </span>
      </div>
      <p class="text-muted small mb-4">Txn: <code>{{ successResult.transactionId }}</code></p>
      <button class="btn btn-primary px-4" (click)="startNew()">
        <i class="pe-7s-refresh me-2"></i>New Transaction
      </button>
    </div>
  </div>

  <!-- ══ MAIN FLOW ═══════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="!successResult">

    <!-- Error alert -->
    <div class="alert alert-danger d-flex align-items-center gap-2 mb-3" *ngIf="errorMessage && !member">
      <i class="pe-7s-attention flex-shrink-0"></i>
      <span class="flex-grow-1">{{ errorMessage }}</span>
      <button type="button" class="btn-close" (click)="errorMessage=''"></button>
    </div>

    <!-- ── STEP 1 : Find Member ────────────────────────────────────────────── -->
    <div class="card mb-3" *ngIf="!member">
      <div class="card-header d-flex align-items-center gap-2">
        <i class="pe-7s-user text-primary"></i>
        <span class="fw-semibold">Find Member</span>
      </div>
      <div class="card-body p-0">
        <div class="ir-two-col">

          <!-- Left: search fields -->
          <div class="ir-search-col">
            <div class="ir-search-grid">

              <div class="ir-search-field">
                <label class="form-label fw-semibold mb-1">Member No</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="pe-7s-id"></i></span>
                  <input type="text" class="form-control" placeholder="e.g. 42"
                    [(ngModel)]="searchNo" (keyup.enter)="searchByField('no')"
                    [disabled]="isMembersSearching || isMemberLookup" />
                  <button class="btn btn-primary" (click)="searchByField('no')"
                    [disabled]="!searchNo.trim() || isMembersSearching || isMemberLookup">
                    <i class="pe-7s-search me-1"></i>Search
                  </button>
                </div>
              </div>

              <div class="ir-search-field">
                <label class="form-label fw-semibold mb-1">Name</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="pe-7s-user"></i></span>
                  <input type="text" class="form-control" placeholder="e.g. Jagruti"
                    [(ngModel)]="searchName" (keyup.enter)="searchByField('name')"
                    [disabled]="isMembersSearching || isMemberLookup" />
                  <button class="btn btn-primary" (click)="searchByField('name')"
                    [disabled]="searchName.trim().length < 3 || isMembersSearching || isMemberLookup">
                    <i class="pe-7s-search me-1"></i>Search
                  </button>
                </div>
                <div class="form-text">Min 3 characters. Fuzzy / phonetic matching enabled.</div>
              </div>

              <div class="ir-search-field">
                <label class="form-label fw-semibold mb-1">Mobile No</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="pe-7s-phone"></i></span>
                  <input type="tel" class="form-control" placeholder="e.g. 9876543210"
                    [(ngModel)]="searchPhone" (keyup.enter)="searchByField('phone')"
                    [disabled]="isMembersSearching || isMemberLookup" />
                  <button class="btn btn-primary" (click)="searchByField('phone')"
                    [disabled]="!searchPhone.trim() || isMembersSearching || isMemberLookup">
                    <i class="pe-7s-search me-1"></i>Search
                  </button>
                </div>
              </div>

            </div>
          </div><!-- /search col -->

          <!-- Right: results -->
          <div class="ir-results-col">

            <div class="text-center py-3" *ngIf="isMembersSearching">
              <span class="spinner-border text-primary"></span>
              <p class="mt-2 mb-0 text-muted small">Searching…</p>
            </div>

            <div class="ir-search-hint" *ngIf="!isMembersSearching && !hasSearched">
              <i class="pe-7s-search"></i>
              <p>Search results will appear here.</p>
            </div>

            <ng-container *ngIf="!isMembersSearching && hasSearched">

              <div class="ir-member-results" *ngIf="memberResults.length > 0">
                <div class="ir-member-results-hdr">
                  <span class="text-muted small">
                    {{ memberResults.length }} result{{ memberResults.length === 1 ? '' : 's' }} for
                    <em>{{ searchedFor }}</em>
                  </span>
                  <span class="spinner-border spinner-border-sm text-primary" *ngIf="isMemberLookup"></span>
                </div>
                <div class="ir-member-results-body">
                  <div class="ir-member-result-item"
                       *ngFor="let m of memberResults"
                       (click)="!isMemberLookup && selectMember(m)"
                       [class.ir-result-active]="selectedMemberId === m._id && isMemberLookup"
                       [class.ir-result-disabled]="isMemberLookup">
                    <div class="ir-avatar ir-avatar-xs flex-shrink-0">{{ m.name?.charAt(0)?.toUpperCase() }}</div>
                    <div class="flex-grow-1 overflow-hidden">
                      <div class="fw-semibold small text-truncate">{{ m.name }}</div>
                      <div class="ir-result-sub text-muted text-truncate">
                        {{ m.phone }}{{ m.area ? ' · ' + m.area : '' }}
                      </div>
                    </div>
                    <span [class]="memberStatusBadge(m).cls + ' flex-shrink-0'">{{ memberStatusBadge(m).label }}</span>
                    <span class="spinner-border spinner-border-sm text-primary flex-shrink-0"
                          *ngIf="isMemberLookup && selectedMemberId === m._id"></span>
                  </div>
                </div>
              </div>

              <div class="ir-empty-state" *ngIf="memberResults.length === 0">
                <i class="pe-7s-users"></i>
                <p>No members found for <em>{{ searchedFor }}</em>.</p>
                <p class="small">Try a different spelling or search by mobile number.</p>
              </div>

            </ng-container>

          </div><!-- /results col -->

        </div>
      </div>
    </div>

    <!-- ── STEP 2 : Member Banner ──────────────────────────────────────────── -->
    <div class="ir-member-banner card mb-2" *ngIf="member">
      <div class="card-body py-2">
        <div class="d-flex align-items-start gap-3">
          <div class="ir-avatar flex-shrink-0">{{ member.name?.charAt(0)?.toUpperCase() }}</div>
          <div class="flex-grow-1 overflow-hidden">
            <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
              <span class="fw-bold fs-6">{{ member.name }}</span>
              <span class="badge" [class.bg-success]="membershipStatus==='active'"
                [class.bg-warning]="membershipStatus==='expiring' || membershipStatus==='hold'"
                [class.bg-danger]="membershipStatus==='closed'">
                {{ membershipStatus==='active' ? 'Active' : membershipStatus==='expiring' ? 'Expiring Soon' : membershipStatus==='hold' ? 'On Hold' : 'Closed' }}
              </span>
              <span class="badge bg-light text-dark border">{{ getCurrentHolding() }}/{{ maxBooks }} books</span>
            </div>
            <div class="d-flex gap-3 flex-wrap text-muted small">
              <span><i class="pe-7s-phone me-1"></i>{{ member.phone }}</span>
              <span *ngIf="member.area">
                <i class="pe-7s-map-marker me-1"></i>{{ member.area }}<span *ngIf="member.landmark">, {{ member.landmark
                  }}</span>
              </span>
              <span *ngIf="member.membershipExpiresOn">
                <i class="pe-7s-date me-1"></i>
                {{ membershipStatus==='closed' || membershipStatus==='hold' ? 'Closed' : 'Valid till' }}
                {{ member.membershipExpiresOn | appDate }}
              </span>
            </div>
          </div>
          <div class="d-flex flex-column gap-2 flex-shrink-0">
            <button class="btn btn-sm btn-outline-secondary" (click)="changeMember()">
              <i class="pe-7s-angle-left me-1"></i>Back
            </button>
            <button class="btn btn-sm btn-warning" *ngIf="membershipStatus==='closed' || membershipStatus==='expiring'" (click)="openRenewModal()">
              <i class="pe-7s-refresh me-1"></i>Renew
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ── STEP 3 : Transaction Card ──────────────────────────────────────── -->
    <div class="card" *ngIf="member && showTransactionUI">

      <!-- Transaction date bar + Save button -->
      <div class="ir-date-bar">
        <label class="ir-date-label" for="txnDate">
          <i class="pe-7s-date me-1"></i>Transaction Date
        </label>
        <input id="txnDate" type="date" class="form-control form-control-sm ir-date-input"
          [(ngModel)]="transactionDate" [max]="todayStr" />
        <span class="text-muted small d-none d-md-inline">Applies to all books in this transaction</span>
        <div class="ms-auto d-flex align-items-center gap-2 flex-shrink-0">
          <div class="alert alert-danger py-1 px-2 mb-0 small d-flex gap-1 align-items-center"
               *ngIf="errorMessage && member">
            <i class="pe-7s-attention flex-shrink-0"></i>{{ errorMessage }}
          </div>
          <button class="btn btn-primary btn-sm px-3" (click)="openConfirmModal()"
            [disabled]="(selectedForReturn.size === 0 && issuedBooks.length === 0) || isSubmitting || !!returnError">
            <span class="spinner-border spinner-border-sm me-1" *ngIf="isSubmitting"></span>
            <i class="pe-7s-check-circle me-1" *ngIf="!isSubmitting"></i>
            {{ isSubmitting ? 'Saving...' : 'Save Transaction' }}
          </button>
        </div>
      </div>

      <div class="card-body p-0">
        <div class="ir-txn-panels">

          <!-- ── Left : Receive Books ──────────────────────────────────────── -->
          <div class="ir-panel">
            <div class="ir-panel-header">
              <span class="fw-semibold text-uppercase small text-nowrap">
                <i class="pe-7s-download text-success me-1"></i>Receive Books
                <span class="badge bg-secondary ms-1 fw-normal">{{ selectedForReturn.size }}</span>
              </span>
              <button class="btn btn-sm btn-outline-secondary ir-panel-btn"
                *ngIf="getBorrowedBooks().length > 0" (click)="toggleSelectAll()">
                {{ selectAll ? 'Deselect All' : 'Select All' }}
              </button>
            </div>

            <div class="ir-empty-state" *ngIf="getBorrowedBooks().length === 0">
              <i class="pe-7s-check text-success"></i>
              <p>No books with this member.</p>
            </div>

            <div class="ir-compact-list" *ngIf="getBorrowedBooks().length > 0">
              <div class="ir-compact-row"
                   *ngFor="let book of getBorrowedBooks(); let i=index"
                   [class.selected]="isSelected(i)"
                   (click)="toggleBookReturn(i)">
                <input type="checkbox" class="form-check-input flex-shrink-0"
                  [checked]="isSelected(i)"
                  (click)="$event.stopPropagation(); toggleBookReturn(i)" />
                <code class="ir-compact-code text-primary flex-shrink-0">{{ book.bookSrNo || book.bookId }}</code>
                <span class="ir-compact-name">{{ book.bookDetails?.bookName || book.bookName }}</span>
              </div>
            </div>

            <div class="ir-panel-stat" *ngIf="selectedForReturn.size > 0">
              <i class="pe-7s-check text-success me-1"></i>
              <span class="small fw-semibold text-success">{{ selectedForReturn.size }} selected for return</span>
            </div>

            <div class="alert alert-warning py-2 px-3 small mb-0 mt-1" *ngIf="returnError">
              <i class="pe-7s-attention me-1"></i>{{ returnError }}
            </div>
          </div>

          <!-- ── Right : Issue Books ───────────────────────────────────────── -->
          <div class="ir-panel">
            <div class="ir-panel-header">
              <span class="fw-semibold text-uppercase small text-nowrap">
                <i class="pe-7s-bookmarks text-primary me-1"></i>Issue Books
                <span class="badge bg-secondary ms-1 fw-normal">{{ issuedBooks.length }}</span>
              </span>
              <div class="d-flex align-items-center gap-2 flex-shrink-0">
                <button *ngIf="allocatedClaims.length > 0"
                        class="ir-reserved-pill" (click)="openReservedModal()">
                  <i class="pe-7s-pin"></i>
                  {{ allocatedClaims.length }} Reserved
                </button>
                <span *ngIf="getAvailableSlots() > 0"
                      class="badge bg-success-subtle text-success-emphasis small">
                  {{ getAvailableSlots() }} more book{{ getAvailableSlots() !== 1 ? 's' : '' }} can be issued
                </span>
                <span *ngIf="getAvailableSlots() <= 0"
                      class="badge bg-danger-subtle text-danger-emphasis small">
                  <i class="pe-7s-attention me-1"></i>Book limit of {{ maxBooks }} reached
                </span>
              </div>
            </div>

            <div class="alert alert-warning py-2 small mb-2" *ngIf="isExpired">
              <i class="pe-7s-attention me-1"></i>Membership closed — cannot issue new books.
            </div>

            <ng-container *ngIf="!isExpired">
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text"><i class="pe-7s-barcode"></i></span>
                <input #bookSrNoField type="text" class="form-control" placeholder="Book Sr No (e.g. 1001)"
                  [(ngModel)]="bookSrNoInput" (keyup.enter)="addBook()"
                  [disabled]="isValidating || getAvailableSlots() <= 0" />
                <button class="btn btn-outline-secondary" title="Scan with camera"
                  (click)="startScan()" [disabled]="isValidating || getAvailableSlots() <= 0">
                  <i class="pe-7s-camera"></i>
                </button>
                <button class="btn btn-success" (click)="addBook()"
                  [disabled]="!bookSrNoInput.trim() || isValidating || getAvailableSlots() <= 0">
                  <span class="spinner-border spinner-border-sm me-1" *ngIf="isValidating"></span>
                  <i class="pe-7s-plus" *ngIf="!isValidating"></i>
                  {{ isValidating ? '' : 'Add' }}
                </button>
              </div>
              <div class="alert alert-warning py-1 px-2 small d-flex gap-1 align-items-center mb-2"
                *ngIf="addError">
                <i class="pe-7s-attention flex-shrink-0"></i>
                <span class="flex-grow-1">{{ addError }}</span>
                <button type="button" class="btn-close btn-close-sm" (click)="addError=''"></button>
              </div>
            </ng-container>

            <div class="ir-empty-state" *ngIf="issuedBooks.length === 0 && !isExpired">
              <i class="pe-7s-bookmarks"></i>
              <p>No books added yet.</p>
              <p class="small">Enter Sr No or scan.</p>
            </div>

            <div class="ir-compact-list" *ngIf="issuedBooks.length > 0">
              <div class="ir-compact-row ir-compact-issue" *ngFor="let book of issuedBooks">
                <i *ngIf="book._fromClaim" class="pe-7s-pin text-warning flex-shrink-0" title="Reserved copy"></i>
                <code class="ir-compact-code flex-shrink-0"
                      [class.text-success]="!book._fromClaim"
                      [class.text-warning]="book._fromClaim">{{ book.bookSrNo }}</code>
                <span class="ir-compact-name">{{ book.bookName }}</span>
                <button class="btn btn-link text-danger p-0 flex-shrink-0"
                  (click)="removeBook(book.bookSrNo)" title="Remove">
                  <i class="pe-7s-trash" style="font-size:1.2rem;"></i>
                </button>
              </div>
            </div>
          </div>

        </div><!-- /ir-txn-panels -->
      </div><!-- /card-body -->

      <!-- Footer: summary chips only -->
      <div class="card-footer ir-footer" *ngIf="selectedForReturn.size > 0 || issuedBooks.length > 0">
        <span class="ir-chip text-success" *ngIf="selectedForReturn.size > 0">
          <i class="pe-7s-download me-1"></i>{{ selectedForReturn.size }} returning
        </span>
        <span class="ir-chip text-primary" *ngIf="issuedBooks.length > 0">
          <i class="pe-7s-bookmarks me-1"></i>{{ issuedBooks.length }} issuing
        </span>
        <span class="ir-chip text-muted">
          After: {{ getCurrentHolding() }}/{{ maxBooks }}
        </span>
      </div>

    </div><!-- /transaction card -->

  </ng-container>

</div><!-- /app-main__inner -->


<!-- ══ RESERVED BOOKS MODAL ══════════════════════════════════════════════════ -->
<div class="bb-overlay" *ngIf="showReservedModal" (click)="closeReservedModal()">
  <div class="bb-modal-card ir-reserved-modal" (click)="$event.stopPropagation()">

    <div class="card-header d-flex align-items-center justify-content-between">
      <span class="fw-semibold">
        <i class="pe-7s-pin me-2 text-warning"></i>
        Reserved for this member
        <span class="badge bg-warning text-dark ms-1">{{ allocatedClaims.length }}</span>
      </span>
      <button class="btn-close" (click)="closeReservedModal()"></button>
    </div>

    <div class="card-body p-0">
      <div class="ir-reserved-list">
        <div class="ir-reserved-item" *ngFor="let claim of allocatedClaims">
          <i class="pe-7s-pin text-warning flex-shrink-0"></i>
          <code class="ir-compact-code text-warning flex-shrink-0">{{ claim.allocatedBookSrNo }}</code>
          <span class="ir-compact-name">{{ claim.bookName }}</span>

          <ng-container *ngIf="!isReservedBookAdded(claim); else alreadyAdded">
            <button class="btn btn-sm btn-outline-success flex-shrink-0 py-0 px-2"
                    (click)="issueReservedBook(claim)"
                    [disabled]="isExpired || getAvailableSlots() <= 0"
                    title="Add to this transaction">
              <i class="pe-7s-plus me-1"></i>Add
            </button>
          </ng-container>
          <ng-template #alreadyAdded>
            <span class="ir-added-badge flex-shrink-0">
              <i class="pe-7s-check me-1"></i>Added
            </span>
            <button class="btn btn-link text-danger p-0 flex-shrink-0"
                    (click)="removeBook(claim.allocatedBookSrNo)" title="Remove from transaction">
              <i class="pe-7s-trash" style="font-size:1.1rem;"></i>
            </button>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="card-footer d-flex align-items-center justify-content-between gap-2">
      <span class="small text-muted">
        {{ addedClaimsCount }} of {{ allocatedClaims.length }} added to transaction
      </span>
      <div class="d-flex gap-2">
        <button class="btn btn-warning btn-sm"
                *ngIf="getAvailableSlots() > 0 && !isExpired && addedClaimsCount < allocatedClaims.length"
                (click)="issueAllReserved()">
          <i class="pe-7s-plus me-1"></i>Add All
        </button>
        <button class="btn btn-outline-secondary btn-sm" (click)="closeReservedModal()">Done</button>
      </div>
    </div>

  </div>
</div>


<!-- ══ CAMERA SCAN OVERLAY ══════════════════════════════════════════════════ -->
<div class="ir-scan-overlay" *ngIf="showScanOverlay">
  <div class="ir-scan-modal">
    <div class="ir-scan-header">
      <span class="fw-semibold text-white">
        <i class="pe-7s-camera me-2"></i>Scan Book Barcode
      </span>
      <button class="btn-close btn-close-white" (click)="stopScan()"></button>
    </div>

    <div class="ir-scan-viewport">
      <video #scanVideo id="irScanVideo" class="ir-scan-video" autoplay playsinline muted></video>
      <div class="ir-scan-frame">
        <div class="ir-corner tl"></div>
        <div class="ir-corner tr"></div>
        <div class="ir-corner bl"></div>
        <div class="ir-corner br"></div>
        <div class="ir-scan-beam"></div>
      </div>
    </div>

    <p class="ir-scan-status">
      <span class="spinner-border spinner-border-sm text-light me-2"></span>{{ scanStatus }}
    </p>
    <button class="btn btn-outline-light btn-sm mt-2" (click)="stopScan()">
      <i class="pe-7s-close me-1"></i>Cancel
    </button>
  </div>
</div>


<!-- ══ RENEW MEMBERSHIP MODAL ══════════════════════════════════════════════ -->
<div class="bb-overlay" *ngIf="showRenewModal" (click)="closeRenewModal()">
  <div class="bb-modal-card ir-renew-modal" (click)="$event.stopPropagation()">

    <div class="card-header d-flex align-items-center justify-content-between">
      <span class="fw-semibold">
        <i class="pe-7s-refresh me-2 text-warning"></i>Renew Membership
      </span>
      <button class="btn-close" (click)="closeRenewModal()"></button>
    </div>

    <div class="card-body">
      <div class="ir-confirm-member mb-4">
        <div class="ir-avatar ir-avatar-sm flex-shrink-0">{{ member?.name?.charAt(0)?.toUpperCase() }}</div>
        <div class="overflow-hidden">
          <div class="fw-semibold text-truncate">{{ member?.name }}</div>
          <div class="text-muted small">
            Closed: {{ member?.membershipExpiresOn | appDate }}
          </div>
        </div>
      </div>

      <label class="form-label fw-semibold">Renewal Period</label>
      <div class="d-flex gap-2 flex-wrap mb-3">
        <button class="btn btn-sm" *ngFor="let opt of [{m:3,label:'3 Months'},{m:6,label:'6 Months'},{m:12,label:'1 Year'},{m:24,label:'2 Years'}]"
          [class.btn-primary]="renewMonths===opt.m" [class.btn-outline-secondary]="renewMonths!==opt.m"
          (click)="renewMonths=opt.m">
          {{ opt.label }}
        </button>
      </div>

      <div class="alert alert-info py-2 small">
        <i class="pe-7s-date me-1"></i>
        New expiry will be set to <strong>{{ renewMonths }} month(s)</strong> from today.
      </div>
    </div>

    <div class="card-footer d-flex justify-content-end gap-2">
      <button class="btn btn-outline-secondary" (click)="closeRenewModal()" [disabled]="isRenewing">Cancel</button>
      <button class="btn btn-warning px-4" (click)="renewMembership()" [disabled]="isRenewing">
        <span class="spinner-border spinner-border-sm me-1" *ngIf="isRenewing"></span>
        <i class="pe-7s-check me-1" *ngIf="!isRenewing"></i>
        {{ isRenewing ? 'Renewing...' : 'Confirm Renewal' }}
      </button>
    </div>

  </div>
</div>


<!-- ══ CONFIRM MODAL ═══════════════════════════════════════════════════════ -->
<div class="bb-overlay" *ngIf="showConfirmModal" (click)="closeConfirmModal()">
  <div class="bb-modal-card ir-confirm-modal" (click)="$event.stopPropagation()">

    <div class="card-header d-flex align-items-center justify-content-between">
      <span class="fw-semibold">
        <i class="pe-7s-receipt me-2 text-primary"></i>Confirm Transaction
      </span>
      <button class="btn-close" (click)="closeConfirmModal()"></button>
    </div>

    <div class="card-body">
      <!-- Member row -->
      <div class="ir-confirm-member mb-3">
        <div class="ir-avatar ir-avatar-sm flex-shrink-0">{{ member?.name?.charAt(0)?.toUpperCase() }}</div>
        <div class="overflow-hidden">
          <div class="fw-semibold text-truncate">{{ member?.name }}</div>
          <div class="text-muted small text-truncate">
            {{ member?.phone }}{{ member?.area ? ' · ' + member?.area : '' }}
          </div>
        </div>
      </div>

      <!-- Returning -->
      <div class="mb-3" *ngIf="getReturnBooks().length > 0">
        <div class="ir-section-label text-success mb-2">
          <i class="pe-7s-back me-1"></i>Returning {{ getReturnBooks().length }} book(s)
        </div>
        <div class="ir-confirm-book-row" *ngFor="let b of getReturnBooks()">
          <div class="ir-confirm-spine return-spine"></div>
          <div class="overflow-hidden">
            <div class="small fw-semibold text-truncate">{{ b.bookDetails?.bookName || b.bookName }}</div>
            <code class="text-muted" style="font-size:.75rem;">Sr: {{ b.bookSrNo || b.bookId }}</code>
          </div>
        </div>
      </div>

      <!-- Issuing -->
      <div class="mb-3" *ngIf="issuedBooks.length > 0">
        <div class="ir-section-label text-primary mb-2">
          <i class="pe-7s-bookmarks me-1"></i>Issuing {{ issuedBooks.length }} book(s)
        </div>
        <div class="ir-confirm-book-row" *ngFor="let b of issuedBooks">
          <div class="ir-confirm-spine issue-spine"></div>
          <div class="overflow-hidden">
            <div class="small fw-semibold text-truncate">{{ b.bookName }}</div>
            <code class="text-muted" style="font-size:.75rem;">Sr: {{ b.bookSrNo }}</code>
          </div>
        </div>
      </div>

      <!-- Holdings summary -->
      <div class="ir-holdings-row mb-3">
        <i class="pe-7s-library text-muted me-2"></i>
        <span class="text-muted small">
          Holdings after: <strong>{{ getCurrentHolding() }}/{{ maxBooks }}</strong>
        </span>
        <span class="ms-auto text-muted small">
          <i class="pe-7s-date me-1"></i>
          Date: <strong>{{ transactionDate | appDate }}</strong>
        </span>
      </div>

      <!-- Remarks -->
      <div>
        <label class="form-label small fw-semibold text-muted mb-1">
          <i class="pe-7s-comment me-1"></i>Remarks <span class="fw-normal">(optional)</span>
        </label>
        <textarea class="form-control form-control-sm" rows="2" maxlength="300"
                  placeholder="e.g. Member requested specific shelf..." [(ngModel)]="remarks"></textarea>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-end gap-2">
      <button class="btn btn-outline-secondary" (click)="closeConfirmModal()">Cancel</button>
      <button class="btn btn-primary px-4" (click)="saveTransaction()">
        <i class="pe-7s-check me-1"></i>Confirm & Save
      </button>
    </div>

  </div>
</div>
